
<template>
  <Loader v-if="loader" />

  <div class="card">
      <div class="formgrid grid ">
          <div class="field col-12 md:col-4">
              <label>Fornitore</label>
              <Dropdown v-model="selectedFornitore" :options="fornitori" :filter="true" optionLabel="ragsoc" optionValue="id" placeholder="Seleziona fornitore" :class="['inputfield w-full',{'p-invalid': validationErrors.fornitore && submitted}]" />
              <div v-show="validationErrors.fornitore && submitted" class="p-error">Seleziona fornitore.</div>
          </div>
          <div class="field col-12 md:col-4">
              <label>Data</label>
              <Calendar v-model="date" :showIcon="true" selectionMode="range" view="month" dateFormat="mm-yy" :class="['inputfield w-full',{'p-invalid': validationErrors.date && submitted}]" />
              <div v-show="validationErrors.date && submitted" class="p-error">Seleziona data.</div>
          </div>
          <div class="field col-12 md:col-4 flex align-items-end justify-content-end">
              <Button label="Cerca" icon="pi pi-search" iconPos="left"  @click="searchData" />
          </div>
      </div>
  </div>

  <div class="grid box-wrapper" v-if="originalInvoices.length">
    <div class="col-12 lg:col-6 xl:col-3 box" @click="filterData(1)" :class="{highlight:selectedBox.includes(1)}"> 
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr Stimati <small>(fornitore)</small></span>
						<div class="text-600 font-medium text-xl">{{pdr_stimati}} <small class="small">su {{originalInvoices.length}} totali</small></div>
					</div>
					<div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell text-blue-500 text-xl"></i>
					</div>
				</div>
        <span class="text-500">Totale: {{pdr_stimati_euro}}</span>
			</div>
		</div>
    <div class="col-12 lg:col-6 xl:col-3 box"  @click="filterData(2)" :class="{highlight:selectedBox.includes(2)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr Reali <small>(fornitore)</small></span>
						<div class="text-600 font-medium text-xl">{{pdr_reali}} <small class="small">su {{originalInvoices.length}} totali</small></div>
					</div>
					<div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell text-blue-500 text-xl"></i>
					</div>
				</div>
        <span class="text-500">Totale: {{pdr_reali_euro}}</span>
			</div>
		</div>
    <div class="col-12 lg:col-6 xl:col-3 box" @click="filterData(3)" :class="{highlight:selectedBox.includes(3)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr Anomali (smc)</span>
						<div class="text-600 font-medium text-xl">{{pdr_anomali}}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-square-warn border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell bell-warn text-xl"></i>
					</div>
				</div>
        <span class="text-500">Totale: {{pdr_anomali_energia}} smc</span>
			</div>
		</div>
    <div class="col-12 lg:col-6 xl:col-3 box" @click="filterData(4)" :class="{highlight:selectedBox.includes(4)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr Anomali (€)</span>
						<div class="text-600 font-medium text-xl">{{pdr_anomali_eur}}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-square-warn border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell bell-warn text-xl"></i>
					</div>
				</div>
        <span class="text-500">Totale: {{pdr_anomali_eur_tot}}</span>
			</div>
		</div>
    <div class="col-12 lg:col-4 xl:col-4 box" @click="filterData(5)" :class="{highlight:selectedBox.includes(5)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr fatt. bimestrale</span>
						<div class="text-600 font-medium text-xl mb-2">{{pdr_bimestrali}}</div>
            <small> su {{originalInvoices.length}} totali</small>
					</div>
					<div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell text-blue-500 text-xl"></i>
					</div>
				</div>
			</div>
		</div>
    <div class="col-12 lg:col-4 xl:col-4 box" @click.stop="filterData(6)" :class="{highlight:selectedBox.includes(6)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr con ricavi (> {{percentageRevenues}}%)   
              <Slider @click.stop="false"  v-model="percentageRevenues" class="mt-1"/> 
              <!-- @change="onChangePercentage" -->
            </span>
						<div class="text-600 font-medium text-xl">{{pdr_ricavi_percentage}} </div>   
					</div>
					<div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell text-blue-500 text-xl"></i>
					</div>
				</div>
        <span class="text-500">Totale: {{pdr_ricavi_percentage_tot}} </span>
			</div>
		</div>
    <div class="col-12 lg:col-4 xl:col-4 box" @click.stop="filterData(7)" :class="{highlight:selectedBox.includes(7)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr ricavi anomali (> {{percentageRevenuesAbnormal}}%)
              <Slider :min="101" :max="500" @click.stop="false"  v-model="percentageRevenuesAbnormal" class="mt-1"/>
            </span>
						<div class="text-600 font-medium text-xl">{{pdr_ricavi_anomali}}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-square-warn border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell bell-warn text-xl"></i>
					</div>
				</div>
        <span class="text-500">Totale: {{pdr_ricavi_anomali_tot}}</span>
			</div>
		</div>
    <div class="col-12 lg:col-4 xl:col-4 box" @click="filterData(8)" :class="{highlight:selectedBox.includes(8)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr fatturati </span>
						<div class="text-600 font-medium text-xl mb-2">{{pdr_fatturati}} <small class="small">su {{originalInvoices.length}} totali</small></div>
					</div>
					<div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell text-blue-500 text-xl"></i>
					</div>
				</div>
        <span class="text-500">Totale: {{pdr_fatturati_euro_fornitore}} </span>
			</div>
		</div>
    <div v-if="pdr_not_found.length > 0" class="col-12 lg:col-4 xl:col-4 box danger" @click="filterData(9)" :class="{highlight:selectedBox.includes(9)}">
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3">Pdr non trovati (in ask) </span>
						<div class="font-medium text-xl mb-2">{{pdr_not_found.length}} <small class="small">su {{originalInvoices.length}} totali</small></div>
					</div>
					<div class="flex align-items-center justify-content-center bg-square-warn border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-bell bell-warn text-xl"></i>
					</div>
				</div>
        <span class="">Totale: {{pdr_non_trovati_euro_acquistati}} </span>
			</div>
		</div>
  </div>


  <div class="remove-filter" v-if="selectedBox.length > 0">
    <Button label="Rimuovi tutti i filtri" icon="pi pi-times-circle" iconPos="right" @click="removeFilter" />
  </div>


  <div class="card">
      <DataTable ref="dt" :value="invoices" :paginator="true" :rows="10" :filters="filters" 
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50,500]" responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                   <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-download" label="Esporta" @click="exportCSV($event)" class="p-button-secondary ml-2" />
                </div>
            </div>
          </template>
          
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <ColumnGroup type="header">
            <Row>
                <Column header="" :colspan="1" />
                <Column header="" :colspan="1" />
                <Column header="" :colspan="1" />
                <Column header="" :colspan="1" />
                <Column class="th-acquistato" header="ACQUISTATO" :colspan="4" />
                <Column class="th-venduto" header="VENDUTO" :colspan="4" />
                <Column header="CHECK" :colspan="3" />
            </Row>
             <Row>
                <Column field="PDR" header="Pdr" />
                <Column field="cliente" header="Cliente" />
                <Column field="rappresentante" header="Rappresentante" />
                <Column field="competenza" header="Competenza" :sortable="true" />
                <Column field="TIPO_MISURA" class="th-acquistato" header="Stima" :sortable="true" /> 
                <Column field="tot_cmor_acquistato" class="th-acquistato" header="Cmor" :sortable="true" /> 
                <Column field="QUANTITA_ENERGIA" class="th-acquistato" header="Totale smc" :sortable="true"/>
                <Column field="tot_eur" class="th-acquistato" header="Totale €" :sortable="true"/>
                <Column field="is_stima_name" class="th-venduto" header="Stima" :sortable="true" />
                <Column field="tot_cmor_venduto" class="th-venduto" header="Cmor" :sortable="true" />
                <Column field="qe_venduto" class="th-venduto" header="Totale smc" :sortable="true"/>
                <Column field="tot_euro_venduto" class="th-venduto" header="Totale €" :sortable="true"/>
                <Column  field="qe_diff" header="smc" :sortable="true"/>
                <Column  field="qeur_diff" header="€" :sortable="true"/>
                <Column  field="cod_type_periodo_name" header="Fatt." :sortable="true"/>

            </Row>
          </ColumnGroup>
          <Column field="PDR">
           <template #body="{data}">
              <p v-if="data.pdr_id == 0">
               {{data.PDR}}
              </p>
              <p v-else>
                <router-link :to="`/ask/pdrs/${data.pdr_id}/dettagli`" target="_blank">
                  {{data.PDR}}
                </router-link>
              </p>
            </template>
          </Column>
          <Column field="cliente" class="border-lt">
            <template field="data.cliente" #body="{data}">
              {{data.cliente}}     
            </template>
          </Column>
          <Column field="rappresentante" class="border-lt">
            <template field="data.rappresentante" #body="{data}">
              {{data.rappresentante}}     
            </template>
          </Column>
          <Column field="competenza" class="border-lt">
            <template field="data.competenza" #body="{data}">
              {{data.competenza}}     
            </template>
          </Column>
          <Column field="TIPO_MISURA" class="border-lt">
            <template field="data.TIPO_MISURA" #body="{data}">
              {{data.TIPO_MISURA.includes('Stima') ? 'Si' : 'No'}}     
            </template>
          </Column>
          <Column field="tot_cmor_acquistato">
            <template #body="{data}">
               {{data.tot_cmor_acquistato}}    
            </template>
          </Column>
          <Column field="QUANTITA_ENERGIA"  >
            <template #body="{data}">
              {{data.QUANTITA_ENERGIA.toFixed(2)}}     
            </template>
          </Column>
          <Column field="tot_eur" >
            <template #body="{data}">
              {{data.tot_eur.toFixed(2)}}     
            </template>
          </Column>
          <Column field="is_stima_name" class="border-lt" />
          <Column field="tot_cmor_venduto">
            <template #body="{data}">
              {{data.tot_cmor_venduto}}     
            </template>
          </Column>
          <Column field="qe_venduto" >
            <template #body="{data}">
              {{data.qe_venduto.toFixed(2)}}     
            </template>
          </Column>
          <Column field="tot_euro_venduto" >
            <template #body="{data}">
              {{data.tot_euro_venduto.toFixed(2)}}     
            </template>
          </Column>
          <Column field="qe_diff" class="border-lt" >
           <template #body="{data}">
              <p :class="data.qe_diff < 0 ? 'p-error' : ''">{{data.qe_diff.toFixed(2)}}</p>     
            </template>
          </Column>
          <Column field="qeur_diff" class="border-lt" >
            <template #body="{data}">
              <p :class="data.qeur_diff < 0 ? 'p-error' : ''">{{data.qeur_diff.toFixed(2)}}</p>     
            </template>
          </Column>
          <Column field="cod_type_periodo_name" class="border-lt"  />
          <ColumnGroup type="footer">
            <Row>
              <Column :colspan="5" class="td-footer" />
              <Column class="td-footer" :footer="totale_cmor_acquistato" />
              <Column :colspan="1" class="td-footer" :footer="totale_energia_acquistato" footerStyle="text-align:right" />
              <Column :colspan="1" class="td-footer" :footer="totale_euro_acquistato" footerStyle="text-align:right" />
              <Column :colspan="1" class="td-footer" />
              <Column class="td-footer" :footer="totale_cmor_venduto" />
              <Column class="td-footer" :footer="totale_energia_venduto" />
              <Column class="td-footer" :footer="totale_euro_venduto" />
              <Column class="td-footer" :footer="totale_diff_energia" />
              <Column class="td-footer" :footer="totale_diff_euro" />
              <Column :colspan="1" class="td-footer" /> 
            </Row>
          </ColumnGroup>
          
      </DataTable>
  </div>

</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance, computed, watch  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
    setup() {

      const dt = ref();
      const loader = ref(false)
      const invoices = ref([]);
      const pdr_not_found = ref([]);
      const originalInvoices = ref([]);
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const date = ref();
      const fornitori = ref([]);
      const selectedFornitore = ref('')
      const percentageRevenues = ref(30)
      const percentageRevenuesAbnormal = ref(101)
      const selectedBox = ref([])
      const validationErrors = ref({})
      const submitted = ref(false)

      onMounted(() => {       
          getFornitoriHasDetails()  
      })
      const searchData = () => {
        selectedBox.value = []
        submitted.value = true;
        if (validateData()) {
          loader.value = true
          let date_start = moment(date.value[0]).format('YYYY-MM-DD')
          let date_end = moment(date.value[0]).format('YYYY-MM-DD')
          if (date.value[1] != null) {
            date_end = moment(date.value[1]).format('YYYY-MM-DD')
          }
          service.getConsumptionsControlloFattureFornitoriGas(
            date_start,
            date_end,
            selectedFornitore.value,
          ).then((res) => {
            invoices.value = res.items.data
            pdr_not_found.value = res.items.pdr_not_found
            originalInvoices.value = invoices.value
          }).finally(() => {
              loader.value = false
          })
        }
      }


      const getFornitoriHasDetails = () =>{
        loader.value = true
        service.getFornitoriControlloFattureHasDetailsGas().then((res) => {
          fornitori.value = res.items
        }).finally(() => {
          loader.value = false
        })
      }

      const filterData = (boxId, freeze) => {

        if (!selectedBox.value.includes(boxId)) {
          selectedBox.value.push(boxId)
        } else {
          if(!freeze){
            selectedBox.value = selectedBox.value.filter(el => el != boxId);
          }
          
        }

        invoices.value = originalInvoices.value

        if (selectedBox.value.includes(1)) {
          getPdrStimati()
        } 

        if (selectedBox.value.includes(2)) {
          getPdrReali()
        } 

        if (selectedBox.value.includes(3)) {
          getPdrAnomaliEE()
        }

        if (selectedBox.value.includes(4)) {
          getPdrAnomaliEuro()
        }

        if (selectedBox.value.includes(5)) {
          getPdrBimestrali()
        }

        if (selectedBox.value.includes(6)) {
          getPdrPercentageRicavi()
        }

        if (selectedBox.value.includes(7)) {
          getPdrRicaviAnomali()
        }

        if (selectedBox.value.includes(8)) {
          getPdrFatturati()
        }

        if (selectedBox.value.includes(9)) {
          getPdrNonTrovati()
        }

      }

      watch(percentageRevenues, () => {
        if (selectedBox.value.includes(6)) {
          filterData(6, true)
        }
      })

      watch(percentageRevenuesAbnormal, () => {
        if (selectedBox.value.includes(7)) {
          filterData(7, true)
        }
      })


      const totale_euro_acquistato = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.tot_eur;
          }
          return formatCurrency(total);
      });

      const totale_energia_acquistato = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.QUANTITA_ENERGIA;
          }
          return formatNumber(total);
      });

      const totale_cmor_acquistato = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.tot_cmor_acquistato;
          }
          return formatCurrency(total);
      });
      
      const totale_euro_venduto = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.tot_euro_venduto;
          }
          return formatCurrency(total);
      });

      const totale_energia_venduto = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.qe_venduto;
          }
          return formatNumber(total);
      });

      const totale_cmor_venduto = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.tot_cmor_venduto;
          }
          return formatCurrency(total);
      });

      const totale_diff_energia = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.qe_diff;
          }
          return formatNumber(total);
      });

      const totale_diff_euro = computed(() => {
          let total = 0;
          for(let detail of invoices.value) {
              total += detail.qeur_diff;
          }
          return formatCurrency(total);
      });

      const pdr_stimati = computed(() => {
        let total = invoices.value.filter(el => el.TIPO_MISURA.toLowerCase().includes('stima')).reduce(acc => acc + 1, 0);
        return total;
      });

      const pdr_stimati_euro = computed(() => {
        let total = invoices.value.filter(el => el.TIPO_MISURA.toLowerCase().includes('stima')).reduce((acc,curr) => acc + curr.tot_eur, 0);
        return formatCurrency(total);
      });

      const getPdrStimati = () => {
        // selectedBox.value = 1
        invoices.value = invoices.value.filter(el => el.TIPO_MISURA.toLowerCase().includes('stima'))
      }

      const pdr_reali = computed(() => {
        let total = invoices.value.filter(el => !el.TIPO_MISURA.toLowerCase().includes('stima')).reduce(acc => acc + 1, 0);
        return total;
      });

      const pdr_reali_euro = computed(() => {
        let total = invoices.value.filter(el => !el.TIPO_MISURA.toLowerCase().includes('stima')).reduce((acc,curr) => acc + curr.tot_eur, 0);
        return formatCurrency(total);
      });

      const getPdrReali = () => {
        //selectedBox.value = 2
        invoices.value = invoices.value.filter(el => !el.TIPO_MISURA.toLowerCase().includes('stima'))
        
      }

      const pdr_anomali = computed(() => {
        let total = invoices.value.filter(el => el.qe_diff < -5).reduce(acc => acc + 1, 0);
        return total;
      });

      const pdr_anomali_energia = computed(() => {
        let total = invoices.value.filter(el => el.qe_diff < -5).reduce((acc, curr) => acc + curr.qe_diff, 0);
        return formatNumber(total);
      });

      const getPdrAnomaliEE = () => {
        //selectedBox.value = 3
        invoices.value = invoices.value.filter(el => el.qe_diff < -5)
      }

      const pdr_anomali_eur = computed(() => {
        let total = invoices.value.filter(el => el.qeur_diff < 0).reduce(acc => acc + 1, 0);
        return total;
      });

      const pdr_anomali_eur_tot = computed(() => {
        let total = invoices.value.filter(el => el.qeur_diff < 0).reduce((acc, curr) =>  acc + curr.qeur_diff, 0);
        return formatCurrency(total);
      });

      const getPdrAnomaliEuro = () => {
        //selectedBox.value = 4
        invoices.value = invoices.value.filter(el => el.qeur_diff < 0)
      }

      
      const pdr_bimestrali = computed(() => {
        let total = invoices.value.filter(el => el.cod_type_periodo == 2).reduce(acc =>  acc + 1, 0);
        return formatNumber(total);
      });

      const getPdrBimestrali = () => {
        //selectedBox.value = 5
        invoices.value = invoices.value.filter(el => el.cod_type_periodo == 2)
      }

      const pdr_fatturati = computed(() => {
        let total = invoices.value.filter(el => el.tot_euro_venduto != 0).reduce(acc =>  acc + 1, 0);
        return formatNumber(total);
      });

      const getPdrFatturati = () => {
        //selectedBox.value = 8
        invoices.value = invoices.value.filter(el => el.tot_euro_venduto != 0)
      }

      const getPdrNonTrovati= () => {
        //selectedBox.value = 9
        invoices.value = invoices.value.filter(el => el.not_found)
      }

      const pdr_fatturati_euro_fornitore = computed(() => {
        let total = 0;
          for(let detail of invoices.value) {
            if (detail.tot_euro_venduto != 0) {
              total += detail.tot_eur;
            }
          }
          return formatCurrency(total);
      });

      const pdr_ricavi_percentage = computed(() => {
         let total = invoices.value.filter((el)=> {
          let percentage = (el.tot_eur/100) * percentageRevenues.value
          if (el.qeur_diff > 0 &&  el.qeur_diff >= percentage ) {
            return el
          }
        }).reduce(acc => acc + 1, 0);
        return total;
      });

      const pdr_ricavi_percentage_tot = computed(() => {
         let total = invoices.value.filter((el)=> {
          let percentage = (el.tot_eur/100) * percentageRevenues.value
          if (el.qeur_diff > 0 &&  el.qeur_diff >= percentage ) {
            return el
          }
        }).reduce((acc,curr) => acc + curr.qeur_diff, 0);
        return formatCurrency(total);
      });

      
      const getPdrPercentageRicavi = () => {
        //selectedBox.value = 6
        invoices.value = invoices.value.filter((el)=> {
          let percentage = (el.tot_eur/100) * percentageRevenues.value
          if (el.qeur_diff > 0 &&  el.qeur_diff >= percentage ) {
            return el
          }
        })
      }


      const pdr_ricavi_anomali = computed(() => { 
        let total = invoices.value.filter((el)=> {
          let percentage = (el.tot_eur/100) * percentageRevenuesAbnormal.value
          if (el.qeur_diff > 0 &&  el.qeur_diff >= percentage ) {
            return el
          }
        })
        .reduce(acc =>  acc + 1, 0);
        return formatNumber(total);
      });

      
      const pdr_ricavi_anomali_tot = computed(() => {
          let total = invoices.value.filter((el)=> {
          let percentage = (el.tot_eur/100) * percentageRevenuesAbnormal.value
          if (el.qeur_diff > 0 &&  el.qeur_diff >= percentage ) {
            return el
          }
        })
        .reduce((acc,curr) =>  acc + curr.qeur_diff, 0);
        return formatCurrency(total);
      });


      const getPdrRicaviAnomali = () => {
          invoices.value = invoices.value.filter((el)=> {
          let percentage = (el.tot_eur/100) * percentageRevenuesAbnormal.value
          if (el.qeur_diff > 0 &&  el.qeur_diff >= percentage ) {
            return el
          }
        })
      }


      const pdr_non_trovati_euro_acquistati = computed(() => {
        let total = 0;
        for(let detail of pdr_not_found.value) {
            total += detail.tot_eur;
        }
        return formatCurrency(total);
      })

      
      const removeFilter = () => {
        selectedBox.value = []
        percentageRevenues.value = 30
        invoices.value = originalInvoices.value
      }

      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

      const formatNumber = (value) => {
        return value.toLocaleString('it-IT');
      };

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      const validateData = () =>{
          if (date.value == null)
            validationErrors.value['date'] = true;
          else 
            delete validationErrors.value['date'];

        if (selectedFornitore.value == '')
            validationErrors.value['fornitore'] = true;
          else 
            delete validationErrors.value['fornitore'];
    
        return !Object.keys(validationErrors.value).length;
      }


      return { 
        dt,
        invoices,
        pdr_not_found,
        originalInvoices,
        loader, 
        filters, 
        date,
        fornitori,
        selectedFornitore,
        searchData,
        exportCSV,
        validationErrors,
        submitted,
        totale_euro_acquistato,
        totale_energia_acquistato,
        totale_cmor_acquistato,
        totale_cmor_venduto,
        totale_euro_venduto,
        totale_energia_venduto,
        totale_diff_energia,
        totale_diff_euro,
        filterData,
        pdr_stimati,
        pdr_stimati_euro,
        getPdrStimati,
        pdr_reali,
        pdr_reali_euro,
        getPdrReali,
        pdr_anomali,
        pdr_anomali_energia,
        getPdrAnomaliEE,
        pdr_anomali_eur,
        pdr_anomali_eur_tot,
        getPdrAnomaliEuro,
        pdr_bimestrali,
        getPdrBimestrali,
        pdr_fatturati,
        pdr_fatturati_euro_fornitore,
        pdr_ricavi_percentage,
        pdr_ricavi_percentage_tot,
        getPdrPercentageRicavi,
        pdr_ricavi_anomali,
        pdr_ricavi_anomali_tot,
        getPdrRicaviAnomali,
        percentageRevenues,
        percentageRevenuesAbnormal,
        pdr_non_trovati_euro_acquistati,
        selectedBox,
        removeFilter
      }
  }
}
</script>



<style>
.p-datatable .p-datatable-thead > tr > th.th-venduto {
  background: bisque !important;
}
.p-datatable .p-datatable-thead > tr > th.th-acquistato {
  background: rgb(184, 225, 251) !important;
}

.p-datatable .p-datatable-thead > tr > th.col-venduto {
  background: bisque;
}
.p-datatable .p-datatable-tbody > tr > td.border-lt {
  border-left: 1px solid rgba(62, 62, 62, 0.251);
}
.p-datatable .p-datatable-tfoot > tr > td.td-footer {
 color: #0a8cf5 !important;
 font-size: 15px;
}
.box-wrapper .bg-square-warn {
  background-color: #f9d3d3;
}
.box-wrapper .bell-warn {
  color: #f72727;
}
.box-wrapper .box {
  cursor: pointer;
}
.box-wrapper .box .card {
    background-color: #f4f4f4;
}
.box-wrapper .highlight .card{
  /* background: rgba(66, 244, 17, 0.195); */
  border-bottom: 6px solid rgb(18, 158, 251);
  background-color: #fff;
}
.remove-filter {
  margin-bottom: 20px;
  text-align: right;
}
.remove-filter button{
  cursor: pointer;
  background-color: #ffffff;
  border: none;
  color: rgb(249, 93, 93);
}
.small {
  font-size: 12px;
  font-weight: 400;
}
</style>
